import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
// apparently TypedUseSelectorHook is accidently deperecated- still recommended to use it. https://stackoverflow.com/questions/64895977/use-of-createselectorhook-instead-of-deprecated-typeduseselectorhook#comment119475430_64925266
import { AppDispatch, RootState } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector; // wrapper to help typescript see types on Rootstate
